import { render, staticRenderFns } from "./Prospectus.vue?vue&type=template&id=1482b369&scoped=true&"
import script from "./Prospectus.vue?vue&type=script&lang=js&"
export * from "./Prospectus.vue?vue&type=script&lang=js&"
import style0 from "./Prospectus.vue?vue&type=style&index=0&id=1482b369&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1482b369",
  null
  
)

export default component.exports